import React from "react";
import styled from "styled-components";
import TruncatedText from "../common/TruncatedText";

const PaddedNote = styled(TruncatedText)`
  padding-top: 16px;
  padding-bottom: 16px;
`;

function NoteCell({ note = "" }: { note?: string }) {
  return <PaddedNote>{note}</PaddedNote>;
}

export default NoteCell;
